// @ts-nocheck
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export function CallTrendChart({ data, period }) {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white p-4 rounded-lg shadow">
        <p className="text-center text-gray-500">データがありません</p>
      </div>
    );
  }

  const chartData = {
    labels: data.map(d => formatDate(d.date, period)),
    datasets: [
      {
        label: '通話数',
        data: data.map(d => d.count),
        borderColor: 'rgb(147, 51, 234)',
        backgroundColor: 'rgba(147, 51, 234, 0.1)',
        fill: true,
        tension: 0.4,
        yAxisID: 'y'
      },
      {
        label: '平均通話時間（秒）',
        data: data.map(d => d.avgDuration),
        borderColor: 'rgb(251, 146, 60)',
        backgroundColor: 'rgba(251, 146, 60, 0.1)',
        fill: true,
        tension: 0.4,
        yAxisID: 'y1'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index' as const,
      intersect: false
    },
    plugins: {
      legend: {
        position: 'top' as const
      },
      title: {
        display: true,
        text: '通話数推移'
      }
    },
    scales: {
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        beginAtZero: true,
        ticks: {
          precision: 0
        },
        title: {
          display: true,
          text: '通話数'
        }
      },
      y1: {
        type: 'linear',
        display: true,
        position: 'right',
        beginAtZero: true,
        grid: {
          drawOnChartArea: false
        },
        title: {
          display: true,
          text: '平均通話時間（秒）'
        }
      }
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <div style={{ height: '300px' }}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
}

function formatDate(dateStr, period) {
  const date = new Date(dateStr);
  if (period === '7d' || period === '30d') {
    return `${date.getMonth() + 1}/${date.getDate()}`;
  } else if (period === '90d') {
    return dateStr; // YYYY-MM-DD-W1形式
  } else {
    return `${date.getFullYear()}/${date.getMonth() + 1}`;
  }
}
